import { Injectable } from '@angular/core';
import { Apollo, gql, Mutation } from 'apollo-angular';
import { CreateIdeaChallengeInput } from 'src/generated/graphql';
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };


export type CreateIdeaMutation = { createIdeaReduce: { id: string, title: string, description?: string | null | undefined, authorName: string, role?: string | null | undefined, re: string, turn?: string | null | undefined, managerName?: string | null | undefined, phone?: string | null | undefined, costCenter?: string | null | undefined, contactHour?: string | null | undefined, productiveEquipament: boolean, areaResponsible?: string | null | undefined, areaExtensionLine?: string | null | undefined, email?: string | null | undefined, createdAt: any, updatedAt: any, country?: { id: string, name: string } | null | undefined, authors?: Array<{ id: string, name: string, re: string }> | null | undefined, unity?: { id: string, name: string } | null | undefined, challenge?: { id: string, name: string } | null | undefined } };
export type CreateIdeaMutationVariables = Exact<{
  data: CreateIdeaChallengeInput;
}>;

export const CreateIdeaDocument = gql`
    mutation CreateIdeaReduce($data: CreateIdeaReduceInput!) {
  createIdeaReduce(data: $data) {
    id
    title
    description
    authorName
    role
    re
    turn
    managerName
    phone
    costCenter
    contactHour
    country {
      id
      name
    }
    productiveEquipament
    areaResponsible
    areaExtensionLine
    email
    createdAt
    authors {
      id
      name
      re
    }
    unity {
      id
      name
    }
    challenge {
      id
      name
    }
  }
}
    `;

@Injectable({
  providedIn: 'root'
})
export class CreateIdeaReduceGQL extends Mutation<CreateIdeaMutation, CreateIdeaMutationVariables> {
  document = CreateIdeaDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}